/**
 * @generated SignedSource<<d04ca0012997ec26fd3d98c9f19fa800>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$data = {
  readonly issueLink: {
    readonly relationName: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell";
};
export type linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$key = {
  readonly " $data"?: linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell",
  "selections": [
    {
      "concreteType": "JiraIssueLink",
      "kind": "LinkedField",
      "name": "issueLink",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "relationName"
        }
      ]
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};

(node as any).hash = "d3c2ef6adc622905ad3f0eddc54bd937";

export default node;
